<template>
    <div>
        <form @submit.prevent="submitFilters">
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="date">From Date</label>
                    <b-form-group label-for="start_date" class="akkurate-dark">
                        <b-form-input id="start_date" class="mt-2 field-container fields" type="date"
                            v-model="download_form.start_date">
                        </b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="date">To Date</label>
                    <b-form-group label-for="end_date" class="akkurate-dark">
                        <b-form-input id="end_date" class="mt-2 field-container fields" type="date"
                            v-model="download_form.end_date">
                        </b-form-input>
                    </b-form-group>
                </div>
                <hr class="my-3" />

                <div class="col-12 col-md-12">
                    <label class="akkurate-dark small" for="date">Select Column</label>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group id="checkbox-group-1" v-model="download_form.selected" :options="options"
                            :aria-describedby="ariaDescribedby" name="flavour-1"></b-form-checkbox-group>
                    </b-form-group>
                </div>



            </div>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props: ['download_form'],
    // computed: {
    //     getBranch() {
    //         if (this.form.branch.length > 0) {
    //             const result = this.form.branch.map((index) => {
    //                 return index.name
    //             });
    //             // console.log(result);
    //             return result.join(" | "); // Join array elements with ", "
    //         } else {
    //             return "";
    //         }
    //     }
    // },
    data() {
        return {
            more_details: false,
            // transaction_options: ['Deposit', 'Withdrawal'],
            options: [
                { text: 'Receipt No', value: 'id' },
                { text: 'Product', value: 'account' },
                { text: 'Reference', value: 'reference' },
                { text: 'Customer', value: 'customer_id' },
                { text: 'External Code', value: 'external_code' },
                { text: 'Code', value: 'code' },
                { text: 'Amount', value: 'amount' },
                { text: 'Account No', value: 'account_no' },
                { text: 'Transaction Type', value: 'trans_type' },
                { text: 'Transaction Mode', value: 'trans_mode' },
                { text: 'Phone', value: 'phone_no' },
                { text: 'Status', value: 'trans_status' },
                { text: 'Date', value: 'date' },
                { text: 'Branch', value: 'branch' },
                { text: 'Source', value: 'source' },
                { text: 'User', value: 'created_by' },
            ]
        }
    },
    methods: {
        submitFilters() {
            this.$emit("submitFilters");
        },



        show_more() {
            this.more_details = !this.more_details
        }
    }
}

</script>